module.exports = __webpack_public_path__ + "img/中国船舶重工.67bf3f77.png";